import React from 'react'
import prefetchCmsPage from 'graphql/prefetchers/prefetchCmsPage'
import { initializeApollo } from 'lib/apolloClient'
import { isServer } from 'lib/utils'
import { NextPage, NextPageContext } from 'next'
import { NextSeo } from 'next-seo'

import CmsPageBasic from 'components/CmsPage/CmsPageBasic'
import ContentPage from 'components/ContentPage/ContentPage'
import PublicLayout from 'components/PublicLayout/PublicLayout'
import usePage from 'hooks/usePage'

const SLUG = 'privacy-policy'

const PrivacyPolicy: NextPage = (): JSX.Element => {
  const { page } = usePage(SLUG)

  return (
    <PublicLayout>
      <NextSeo noindex />
      <ContentPage title={page?.title}>
        <CmsPageBasic slug={SLUG} />
      </ContentPage>
    </PublicLayout>
  )
}

PrivacyPolicy.getInitialProps = async (ctx: NextPageContext) => {
  if (isServer()) {
    const apolloClient = initializeApollo(ctx)
    await prefetchCmsPage(apolloClient, { slug: SLUG })

    return {
      initialApolloState: apolloClient.cache.extract(),
    }
  }

  return {}
}

export default PrivacyPolicy
